import axios from '@/utils/request';

export async function shippingDetails(shopifyOrderId) {
    return axios.get(`/shopify/shipping/details`, {
        shopifyOrderId
    });
}